import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { IrisFieldsModule } from '@iris/common/modules/fields/fields.module';
import { AuthRoutingModule } from './auth.routes';
import { IrisLoaderService } from '@iris/common/services/loader.service';
import { AuthComponent } from './auth.component';
import { LanguageSelectModule } from './language-select/language-select.module';
import { SafeUrlPipe } from '@iris/common/modules/pipes-common/pipes/dom-sanitizer/safe-url.pipe';
import {
  StrakitButtonComponent,
  StrakitTextComponent,
} from '@ngx-strakit/cdk/controls';
import {
  StrakitToolbarComponent,
  StrakitToolbarContentCenterDirective,
  StrakitToolbarContentRightDirective,
} from '@ngx-strakit/cdk/layout';
import { WithConfirmDirective } from '@ngx-strakit/cdk/components/confirmation';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    IrisFieldsModule,
    AuthRoutingModule,
    LanguageSelectModule,
    SafeUrlPipe,
    StrakitTextComponent,
    StrakitButtonComponent,
    StrakitToolbarComponent,
    StrakitToolbarContentCenterDirective,
    StrakitToolbarContentRightDirective,
    WithConfirmDirective,
  ],
  providers: [
    IrisLoaderService,
  ],
  declarations: [
    AuthComponent,
  ],
  exports: [TranslateModule],
})
export class AuthModule { }
